import React from "react";

const InputTextarea = ({
  onChange,
  onBlur,
  value,
  error,
  errorMsg,
  placeholder,
  label,
  isSpace,
  className,
  maxLength = 1000000,
  name,
  textareaClassName,
  labelClassName,
  isRequired = true,
  blockHtmlTags = false,
}) => {
  const handleChange = (e) => {
    let inputValue = e.target.value;

    if (blockHtmlTags) {
      inputValue = inputValue.replace(/[<>/]/g, "");
    }

    if (isSpace) {
      inputValue = inputValue.replace(/^\s+/, "");
    }
    if (maxLength) {
      inputValue = inputValue.slice(0, maxLength);
    }

    if (onChange) {
      onChange({
        target: {
          name,
          value: inputValue,
        },
      });
    }
  };
  return (
    <div className={`py-2 ${className}`}>
      <label
        htmlFor={name}
        className={`font-semibold text-[14px] text-foreground ${labelClassName}`}
      >
        {label}
        {isRequired && <span className="text-[#FF5C5C]">*</span>}
      </label>
      {label && <br />}
      <textarea
        name={name}
        onChange={handleChange}
        onBlur={(e) => {
          if (onBlur) {
            onBlur(e);
          }
        }}
        value={value}
        placeholder={placeholder}
        className={`block form-input border border-solid ${error ? "border-red-500" : "border-[#e7e3e4]"
          } focus:outline-none focus-visible:outline-none
    focus-visible:ring-[3px]
    focus-visible:ring-ring/30
    focus-visible:border-ring focus:border-custom-500
    disabled:bg-slate-100 disabled:border-slate-300
    disabled:text-slate-500 placeholder:text-[#b2b2ba]
    placeholder:text-[14px] min-h-[100px] ${textareaClassName}`}
      />
      {error ? (
        <div className="text-[13px] text-red-500">{errorMsg}</div>
      ) : null}
    </div>
  );
};

export default InputTextarea;
